import { render } from "./PersonalInfo.vue?vue&type=template&id=660354ed&scoped=true"
import script from "./PersonalInfo.vue?vue&type=script&lang=js"
export * from "./PersonalInfo.vue?vue&type=script&lang=js"

import "./PersonalInfo.vue?vue&type=style&index=0&id=660354ed&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660354ed"]])

export default __exports__